export class LocalStorageService {
  get(key: string): object | string | number | boolean | unknown[] {
    try {
      return JSON.parse(localStorage.getItem(key))
    } catch (e) {
      return localStorage.getItem(key)
    }
  }

  set(key: string, value: object | string | number | boolean | unknown[]) {
    if (typeof value === 'object' || Array.isArray(value)) {
      localStorage.setItem(key, JSON.stringify(value))
    } else {
      localStorage.setItem(key, value.toString())
    }
  }

  remove(key: string) {
    localStorage.removeItem(key)
  }
}

export const lStorageService = new LocalStorageService()
